<script setup lang="ts">
import { CircleAlert, CircleCheck, Info, X } from '@lucide/vue'

import { useUiStore } from '@/shared/stores/ui.store'
import UiButton from '@/shared/ui/button/UiButton.vue'

const ui = useUiStore()

const icons = {
  success: CircleCheck,
  error: CircleAlert,
  info: Info,
}

const iconClasses = {
  success: 'text-positive',
  error: 'text-danger',
  info: 'text-accent',
}
</script>

<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed right-4 bottom-4 z-[100] flex w-[min(380px,calc(100vw-2rem))] flex-col gap-2"
      aria-live="polite"
      aria-atomic="false"
    >
      <TransitionGroup
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-2 opacity-0"
        leave-active-class="transition duration-150 ease-in"
        leave-to-class="translate-x-2 opacity-0"
      >
        <div
          v-for="toast in ui.toasts"
          :key="toast.id"
          class="pointer-events-auto flex items-start gap-3 rounded-lg border bg-surface p-3.5 shadow-float"
        >
          <component
            :is="icons[toast.tone]"
            :size="18"
            :class="['mt-0.5 shrink-0', iconClasses[toast.tone]]"
          />
          <div class="min-w-0 flex-1">
            <p class="text-sm font-medium">{{ toast.title }}</p>
            <p v-if="toast.description" class="mt-0.5 text-sm leading-5 text-muted">
              {{ toast.description }}
            </p>
          </div>
          <UiButton
            size="icon"
            variant="ghost"
            label="关闭通知"
            class="-mt-1 -mr-1 size-7"
            @click="ui.dismissToast(toast.id)"
          >
            <X :size="14" />
          </UiButton>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
